import { render } from "./yeyResourceHome.vue?vue&type=template&id=7fdb1f98"
import script from "./yeyResourceHome.vue?vue&type=script&lang=js"
export * from "./yeyResourceHome.vue?vue&type=script&lang=js"

import "./yeyResourceHome.vue?vue&type=style&index=0&id=7fdb1f98&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__